module.exports = __webpack_public_path__ + "static/media/purewatt-3.e2c588ab.jpg";